
export const importContentFile = async (
  files,
  basePath,
  layout,
) => {
  const file = files.length > 0 ? files[0] : files;


  const formData = new FormData();
  if (file) {
    formData.append('uploaded_file', file);
  }

  let csrfToken = document.querySelector('meta[name=csrf-token]').content;

  const response = await fetch(
    `/admin/content/import?layout=${layout}`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: formData,
      credentials: 'same-origin',
    }
  );
  const data = await response.json();

  if (data) {
    return data;
  }
};
